import { useState } from "react";

import { useScrollLock } from "../../hooks/useScrollLock";

import {
  ModalContainer,
  Row,
  ModalTitle,
  Label,
  Input,
  InputContainer,
  List,
  ListItem,
  ListItem2,
} from "./RequestWithdrawalModal.styles";

import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";

import Button from "../utils/Button/Button";
import Modal from "../utils/Modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import { createRequestWithdrawal } from "../../store/slices/payment/asyncThunk";
import { toast } from "sonner";
import { selectCreateRequestWithdrawalPending } from "../../store/slices/payment/slice";

const RequestWithdrawalModal = ({ isOpen, onClose }) => {
  const [usdtAddress, setUsdtAddress] = useState("");
  const [amount, setAmount] = useState("");
  const dispatch = useDispatch();
  useScrollLock(isOpen);

  const loading = useSelector(selectCreateRequestWithdrawalPending);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const sendRequest = () => {
    dispatch(createRequestWithdrawal({ amount, walletAddress: usdtAddress }))
      .unwrap()
      .then(() => {
        toast.success(
          "Withdrawal Request Submitted ✅ You can track its status in the History below.",
        );
        onClose();
      })
      .catch((err) => {
        toast.error(
          err.message ?? "Error occurred while creating request withdrawal.",
        );
      });
  };

  return (
    <Modal onClose={handleOverlayClick} isOpen={isOpen}>
      <ModalContainer>
        <Row>
          <ModalTitle>Withdraw</ModalTitle>

          <CloseSvg onClick={onClose} style={{ cursor: "pointer" }} />
        </Row>
        <InputContainer>
          <Label>Solana wallet address (USDT)</Label>
          <Input
            placeholder="Your USDT Address"
            value={usdtAddress}
            onChange={(e) => {
              setUsdtAddress(e.target.value);
            }}
          />
          {/* <TronContainer>
            <TronRow>
              <TronIcon src={TornImg} />
              <TextRow>
                <LightText>Coin</LightText>
                <BoldText>USDT</BoldText>
              </TextRow>
            </TronRow>
            <TextRow>
              <LightText>Network</LightText>
              <Address>TRC20</Address>
            </TextRow>
          </TronContainer> */}
        </InputContainer>
        <InputContainer>
          <Label>Enter Amount</Label>
          <Input
            type="number"
            min={100}
            placeholder="$100"
            value={amount}
            onChange={(e) => {
              setAmount(e.target.value);
            }}
          />
        </InputContainer>
        <List>
          <ListItem>USDT on Solana only.</ListItem>
          <ListItem>Minimum per withdrawal: 100 USDT</ListItem>
          <ListItem2>Payouts are on Monday and Tuesday every week.</ListItem2>
        </List>
        <Button
          title={"Request Withdrawal"}
          disabled={!usdtAddress || amount < 100}
          onClick={sendRequest}
          loading={loading}
          style={{ width: "fit-content", alignSelf: "center" }}
        />
      </ModalContainer>
    </Modal>
  );
};

export default RequestWithdrawalModal;
